import { combineReducers } from '@reduxjs/toolkit';
import routingSlice from './slices/routingSlice';

export const RoutingReducer = combineReducers({
    routing: routingSlice,
});

export default RoutingReducer;
